import { render } from "./professionViewCourse.vue?vue&type=template&id=baa816ca&scoped=true"
import script from "./professionViewCourse.vue?vue&type=script&lang=js"
export * from "./professionViewCourse.vue?vue&type=script&lang=js"

import "./professionViewCourse.vue?vue&type=style&index=0&id=baa816ca&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa816ca"]])

export default __exports__